import * as React from "react";
import { ModelPartnerClient } from "@dia-ui/util_interlink-api";
import { useContext, useEffect, useState } from "react";
import { AppContext } from "app/context/AppContext";
import IconComponent from "../IconComponent";
import { generatePath, useNavigate } from "react-router";

const ClientPartnerDisplayComponentForm: React.FC<{ id: string, type: string }> = ({id, type}) => {
  /**
   * navigate
   */
  const navigate = useNavigate();

  /**
   * context
   */
  const {
    services: {
      servicePartnerClient
    },
    I18N,
    getRoutes
  } = useContext(AppContext);

  /**
   * ROUTE_CONFIG
   */
  const ROUTE_CONFIG = getRoutes();

  /**
   * state variables
   */
  const [partnerClient, setPartnerClient] = useState<ModelPartnerClient>({
    partnerId: "",
    clientId: "",
    active: false,
    config: {},
  } as ModelPartnerClient);

  /**
   * handleTest
   * @param id
   * @param partnerHash
   * @param partnerId
   * @param type
   */
  const handleTest = (id: string, partnerHash: string, partnerId: string, type: string) => {
    navigate(generatePath(ROUTE_CONFIG.CLIENT_PARTNER_TEST.path, {
      id: id,
      partnerHash: partnerHash,
      partnerId: partnerId,
      type: type
    }));
  };

  useEffect(() => {
    const fetchPartnerClient = async () => {
      if (id && type) {
        const partnerClientByIdAndType = await servicePartnerClient.getByIdAndType(id, type);

        setPartnerClient(partnerClientByIdAndType[0]);
      }
    };

    fetchPartnerClient();
  }, [servicePartnerClient, id, type]);

  return (
    <>
      <dia-grid-nested data-grid-nested-full-width>
        <dia-grid-row>
          <dia-grid-column>
            <dia-panel style={{ 'width':'405px' }}>
              <dia-panel-header>
                <IconComponent iconName={ ROUTE_CONFIG.CLIENT_OVERVIEW.icon } />
                <span style={{ marginLeft: "8px" }}>
                  { I18N.t("Allgemeine Daten") }
                </span>
              </dia-panel-header>
              <dia-panel-content>
                <dia-form>
                  <form>
                    <dia-form-area>
                      <dia-form-line>
                        <dia-form-control>
                          <input
                            type="text"
                            name="partner-name"
                            placeholder=""
                            value={ partnerClient ? partnerClient.partnerId : "" }
                            readOnly
                          />
                          <label>{I18N.t("Partner Name")}</label>
                        </dia-form-control>
                      </dia-form-line>
                      <dia-form-line>
                        <dia-form-control>
                          <label>{I18N.t("Status")}</label>
                          <dia-switch>
                            <input
                              type="checkbox"
                              id="status-switch"
                              checked={ !!partnerClient?.active }
                              readOnly
                            />
                            <label htmlFor="status-switch"></label>
                          </dia-switch>
                        </dia-form-control>
                      </dia-form-line>
                    </dia-form-area>
                    { /*<button
                          data-small
                          data-primary-dark
                          data-icon-only
                        >
                          <i
                            data-dia-icon-before="save"
                          ></i>
                        </button> */ }
                  </form>
                </dia-form>
              </dia-panel-content>
              <dia-panel-footer>
                <ul>
                  <li>
                    <button
                      data-secondary
                      onClick={ () => partnerClient?.clientId && partnerClient?.partnerId && handleTest(partnerClient?.clientId, id, partnerClient?.partnerId, type) }
                      title={ ROUTE_CONFIG.CLIENT_TEST.title }
                    >
                      <i data-icon-before={ ROUTE_CONFIG.CLIENT_TEST.icon }></i>
                      { ROUTE_CONFIG.CLIENT_TEST.title }
                    </button>
                  </li>
                </ul>
              </dia-panel-footer>
            </dia-panel>
          </dia-grid-column>
          <dia-grid-column>
            <dia-panel style={{ 'width':'655px' }}>
              <dia-panel-header>
                <IconComponent iconName="laptop-code" />
                { I18N.t("JSON Konfiguration") }
              </dia-panel-header>
              <dia-panel-content data-panel-no-padding>
                <textarea
                  readOnly
                  value={JSON.stringify(partnerClient?.config ?? {}, null, 2)}
                  has="code-mirror"
                ></textarea>
              </dia-panel-content>
            </dia-panel>
          </dia-grid-column>
        </dia-grid-row>
      </dia-grid-nested>
    </>
  );
};

export default ClientPartnerDisplayComponentForm;
